$(function () {
  const offsetY = 0;
  const time = 250;

  $('a[href^=#]').click(function () {
    const target = $(this.hash);
    if (!target.length) return;
    const targetY = target.offset().top + offsetY;
    $('html,body').animate({scrollTop: targetY}, time, 'swing');
    window.history.pushState(null, null, this.hash);
    return false;
  });
});

$(function () {
  $('.fancybox').fancybox({
    helpers: {
      overlay: {
        locked: false
      }
    }
  });
});

$(function() {
  const section = ['cover','summary','information','spec','content'].reverse();

  $(window).scroll(function () {
    var menu = $('#menu');

    for (let value of section) {
      var nodeName = '#'+value;
      var triggerNode = $(nodeName);

      // 引き金となる要素の位置を取得
      // var triggerNodePosition = triggerNode.offset().top - $(window).height();
      var triggerNodePosition = triggerNode.offset().top - 1;

      // 現在のスクロール位置が引き金要素の位置より下にあれば‥
      if ($(window).scrollTop() > triggerNodePosition) {

        menu.find('.menuItem').removeClass('current');
        var className = '.'+value;
        menu.find(className).addClass('current');

        return;
      }
    }
  });
});
